import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AssQuestionDialog(props) {
  const { open, handleClose, yes } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Any Accessorials?</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          It appears that this load is completed. Do you have any accessorial
          charges to add to this load?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          No
        </Button>
        <Button onClick={yes} color="primary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
